/* eslint-disable max-len */
import 'react';

let index = 0;

const RepositoryNewSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => {
    const timeStamp = index++;
    const id = `RepositoryNewSvg-1-${timeStamp}`;
    const id2 = `RepositoryNewSvg-2-${timeStamp}`;

    return (
        <svg width="1em" height="1em" viewBox="0 0 26 26" {...props}>
            <defs>
                <linearGradient
                    x1="15.278%"
                    y1="0%"
                    x2="84.722%"
                    y2="55.407%"
                    id={id}
                >
                    <stop stopColor="#5CBAFF" offset="0%" />
                    <stop stopColor="#5C97FF" offset="100%" />
                </linearGradient>
                <linearGradient
                    x1="50%"
                    y1="0%"
                    x2="50%"
                    y2="98.667%"
                    id={id2}
                >
                    <stop stopColor="#FFF" offset="0%" />
                    <stop stopColor="#FFF" stopOpacity={0.636} offset="100%" />
                </linearGradient>
            </defs>
            <g fill="none" fillRule="evenodd">
                <path d="M1.857 2.1h22.286v22.286H1.857z" />
                <path
                    d="M0 .887C0 .397.397 0 .887 0h15.318a2.366 2.366 0 012.366 2.366v.203H2.361A.62.62 0 002.269 3.8l.092.007h11.403l-.001.004h3.625c.654 0 1.183.53 1.183 1.183v16.107c0 .654-.53 1.184-1.183 1.184H1.183C.53 22.286 0 21.756 0 21.102V.887z"
                    fill={`url(#${id})`}
                    transform="translate(3.714 2.1)"
                />
                <path
                    d="M9.275 9.589c-.966.275-1.704.348-2.337.343H6.92c-.75-.009-1.63-.204-1.732-.223h-.003c-.084-.016-.15.01-.197.071l-.004.006c-.133.19-.207.304-.359.614l-.007.014a.124.124 0 00.075.168l.006.002c.074.022 1.087.328 2.067.348l.03.001c1.177.05 1.98-.196 2.233-.264l.007-.002c.24-.063 1.123-.329 2.128-.343h.03c1.129-.011 1.792.189 1.911.21h.004a.196.196 0 00.202-.076l.004-.006c.079-.104.271-.425.339-.592l.003-.009c.03-.075.009-.148-.07-.183l-.006-.002c-.266-.107-1.089-.319-1.91-.347h-.024a11.33 11.33 0 00-.296-.005h-.029c-.539 0-1.243.046-2.046.275zm2.11 1.932c-.547 0-1.225.037-2.338.335l-.033.01c-.98.278-1.703.283-2.335.262h-.02c-.698-.024-1.633-.26-1.736-.28H4.92a.187.187 0 00-.194.078l-.004.005c-.133.19-.191.281-.344.595l-.007.015c-.029.059-.007.14.068.172l.006.002c.114.042 1.101.365 2.063.414l.03.001c1.137.089 2.052-.142 2.23-.186l.006-.002c.24-.06 1.22-.35 2.13-.399l.028-.001c.996-.05 1.827.127 1.928.144h.002c.1.017.158-.024.196-.075l.003-.004c.05-.069.27-.426.347-.63l.003-.007c.025-.068.003-.144-.075-.174l-.006-.002c-.463-.157-1.253-.27-1.923-.273h-.022zm-.045 2.136c-.548 0-1.23.05-2.35.353-.98.278-1.703.274-2.335.252h-.019c-.699-.024-1.657-.262-1.836-.31l-.005-.002c-.083-.023-.144.02-.19.082l-.003.005c-.133.19-.196.278-.35.592l-.006.015c-.03.059-.008.132.068.163l.006.002c.086.032.43.149.776.232l.012.002c.165.04.587.1.771.315l.007.008c.086.105.187.232.1.596l-.002.011c-.164.671-.43.766-.264.964l.005.006a.283.283 0 00.218.09h.011c.273 0 .634-.231.7-.27h.002c.095-.054.425-.263.588-.365l.007-.005c.374-.234 1.58-1.226 3.125-1.566l.047-.01c1.248-.264 2.215-.021 2.291-.008h.002a.21.21 0 00.194-.065l.005-.006c.07-.084.312-.483.376-.657l.002-.007c.024-.069.01-.144-.073-.174l-.005-.001c-.409-.131-1.229-.239-1.836-.242h-.038z"
                    fill={`url(#${id2})`}
                    transform="translate(3.714 2.1)"
                />
            </g>
        </svg>
    );
};
export default RepositoryNewSvg;
